"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _5KYY6256cjs = require('../__chunks/5KYY6256.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/VRR6XSK3.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-bar-provider.tsx
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
function MenuBarProvider(props = {}) {
  _react.useEffect.call(void 0, () => {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        "MenuBarProvider is deprecated. Use MenubarProvider instead.",
        "See https://ariakit.com/reference/menubar-provider"
      );
    }
  }, []);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _5KYY6256cjs.MenubarProvider, { ...props });
}


exports.MenuBarProvider = MenuBarProvider;
